module.exports = __webpack_public_path__ + "static/media/illustration-grow-together.bb27da81.svg";